import { render, staticRenderFns } from "./ReceptionModal.vue?vue&type=template&id=e04ce20c&scoped=true"
import script from "./ReceptionModal.vue?vue&type=script&lang=js"
export * from "./ReceptionModal.vue?vue&type=script&lang=js"
import style0 from "./ReceptionModal.vue?vue&type=style&index=0&id=e04ce20c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e04ce20c",
  null
  
)

export default component.exports